angular.module('kareo.ui.shared.modules', [
  'kareo.ui.shared.modules.analytics',
  'kareo.ui.shared.modules.dataServices',
  'kareo.ui.shared.modules.data',
  'kareo.ui.shared.modules.idleMonitor'
]);